import {faInbox} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {boundMethod} from "autobind-decorator";
import React from "react";
import {injectIntl, IntlShape} from "react-intl";

import networkDevices from "@/services/network-devices";
import {IQueueDevice} from "./models";

import CheckboxSearchResults from "@toolbox/display-blocks/CheckboxSearchResults";
import Modal, {CancelButton} from "@toolbox/modals/Modal";
import T, {intl2Str} from "@translate/T";

interface IQueueModalProps {
    intl: IntlShape;
    selectedDevices: IQueueDevice[];

    onChange(value: IQueueDevice[]): void;
    onSubmit(firstFree?: boolean): Promise<boolean>;
    afterClose(): void;
}

class QueueModal extends React.PureComponent<IQueueModalProps> {
    private readonly options = [...this.props.selectedDevices];
    private readonly ref = React.createRef<Modal>();

    @boundMethod
    public async firstFree() {
        const success = await this.props.onSubmit(true);
        if (success) {
            this.ref.current?.triggerClose();
        }
    }

    @boundMethod
    public async onSubmit() {
        const success = await this.props.onSubmit();
        if (success) {
            this.ref.current?.triggerClose();
        }
    }

    public render() {
        const {selectedDevices, afterClose, onChange} = this.props;

        return (
            <Modal
                ref={this.ref}
                header={<T>Selected devices to run SOP</T>}
                size="md"
                afterClose={afterClose}
            >
                <div className="modal-body">
                    <CheckboxSearchResults<IQueueDevice>
                        selected={selectedDevices}
                        options={this.options}
                        onChange={onChange}
                        getName={this.renderName}
                        getId={this.renderId}
                        render2ndCol={this.renderErrorMsg}
                    />
                </div>

                <div className="modal-footer">{this.renderFooter()}</div>
            </Modal>
        );
    }

    @boundMethod
    private renderErrorMsg(ref: IQueueDevice) {
        const {intl} = this.props;
        let text = "";
        let foundError = false;

        if (!ref.isOnline) {
            foundError = true;
            text += intl2Str(intl, "Device is not online.") + " ";
        } else {
            text += intl2Str(intl, "Device is online.") + " ";
        }

        if (!networkDevices.isLicensed(ref)) {
            foundError = true;
            text += intl2Str(intl, "Device is not licensed.") + " ";
        } else {
            text += intl2Str(intl, "Device is licensed.") + " ";
        }

        if (!foundError) {
            return <span className="text-primary">{text.slice(0, -1)}</span>;
        }

        return <span className="text-danger">{text.slice(0, -1)}</span>;
    }

    @boundMethod
    private renderName(value: IQueueDevice) {
        return networkDevices.getDeviceName(this.props.intl, value);
    }

    private renderId(value: IQueueDevice) {
        return networkDevices.deviceIdString(value);
    }

    private renderFooter() {
        const {intl} = this.props;
        const className = "btn btn-success";

        return (
            <React.Fragment>
                <div className=/*"btn-group*/ " mr-auto">
                    {/* <button
                        type="button"
                        id="first-free-device"
                        className={className}
                        onClick={this.firstFree}
                        title={intl2Str(
                            intl,
                            "First device free of measurement will perform the SOP.",
                        )}
                    >
                        <FontAwesomeIcon
                            icon={faInbox}
                            fixedWidth={true}
                            className="mr-1"
                        />
                        <T>First free device</T>
                    </button> */}

                    <button
                        type="button"
                        id="execute-queue-sop"
                        className={className}
                        onClick={this.onSubmit}
                        title={intl2Str(
                            intl,
                            "Only checked devices will recieve the SOP.",
                        )}
                    >
                        <FontAwesomeIcon
                            icon={faInbox}
                            fixedWidth={true}
                            className="mr-1"
                        />
                        <T>Queue selected</T>
                    </button>
                </div>

                <CancelButton>
                    <T>Close</T>
                </CancelButton>
            </React.Fragment>
        );
    }
}

export default injectIntl(QueueModal);
